import React from 'react';
import { TextInput } from '@abyss/ui/form/TextInput';
import { Flex } from '@abyss/ui/base/Flex';

export const ProviderInput = () => {
  return (
    <React.Fragment>
      <Flex gutters>
        <Flex.Content space-40>Corporate Provider Name:</Flex.Content>
        <Flex.Content>
          <TextInput
            data-testid="corporate-name"
            model="internalPreference.corporateProviderName"
            validators={{ required: value => !value }}
          />
        </Flex.Content>
      </Flex>
      <Flex gutters>
        <Flex.Content space-40>Corporate Provider MPIN:</Flex.Content>
        <Flex.Content>
          <TextInput
            data-testid="corporate-mpin"
            model="internalPreference.corporateProviderMpin"
            validators={{ required: value => !value }}
          />
        </Flex.Content>
      </Flex>
      <Flex gutters>
        <Flex.Content space-40>Tax ID Number:</Flex.Content>
        <Flex.Content>
          <TextInput
            data-testid="tax-id-number"
            model="internalPreference.taxIdNumber"
            validators={{ required: value => !value }}
          />
        </Flex.Content>
      </Flex>
      <Flex gutters>
        <Flex.Content space-40>Servicing Provider First Name:</Flex.Content>
        <Flex.Content>
          <TextInput
            data-testid="servicing-first-name"
            placeholder="optional"
            model="internalPreference.servicingProviderFirstName"
          />
        </Flex.Content>
      </Flex>
      <Flex gutters>
        <Flex.Content space-40>Servicing Provider Last Name:</Flex.Content>
        <Flex.Content>
          <TextInput
            data-testid="servicing-last-name"
            model="internalPreference.servicingProviderLastName"
            validators={{ required: value => !value }}
          />
        </Flex.Content>
      </Flex>
      <Flex gutters>
        <Flex.Content space-40>Servicing Provider MPIN:</Flex.Content>
        <Flex.Content>
          <TextInput
            data-testid="servicing-mpin"
            model="internalPreference.servicingProviderMpin"
            validators={{ required: value => !value }}
          />
        </Flex.Content>
      </Flex>
    </React.Fragment>
  );
};
